import * as http from './http';
import { stringify } from 'query-string';
import ApiService from './service';
import {
  PaginatedApiResponse,
  ApiResponse,
  Role,
  ApiPermissions,
} from '../models';

export class RoleService extends ApiService {
  public async getAllPermissions(): Promise<ApiPermissions[]> {
    const url = `${this.apiDomain}/api/permission`;

    const resposne = await http.get<PaginatedApiResponse<ApiPermissions>>(
      url,
      this.store
    );
    return resposne.data?.data || [];
  }

  public async getRoles(data: {
    page: number;
    query?: string;
  }): Promise<PaginatedApiResponse<Role> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/role?${stringify(data)}`;

    const resposne = await http.get<PaginatedApiResponse<Role>>(
      url,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async createRole(data: Role): Promise<ApiResponse<Role>> {
    const url = `${this.apiDomain}/api/role`;

    const resposne = await http.post<ApiResponse<Role>>(url, data, this.store);
    return resposne.data;
  }

  public async updateRole(
    id: string,
    data: { permissions: string[] }
  ): Promise<ApiResponse<Role>> {
    const url = `${this.apiDomain}/api/role/${id}`;

    const resposne = await http.put<ApiResponse<Role>>(url, data, this.store);
    return resposne.data;
  }

  public async deleteRole(id: string): Promise<ApiResponse<Role>> {
    const url = `${this.apiDomain}/api/role/${id}`;

    const resposne = await http.remove<ApiResponse<Role>>(url, this.store);
    return resposne.data;
  }
}
